import $ from 'jquery';

$(window).scroll(function () {
	const scroll = $(window).scrollTop(); // Get the current scroll value

	// Check if '.landing-hero' exists
	if ($('.landing-hero').length) {
		const heroBottom = $('.landing-hero').offset().top + $('.landing-hero').outerHeight() - 300; // Get the bottom position of the landing hero
		if (scroll >= heroBottom) { // If we've scrolled past the bottom of the hero...
			$('header').addClass('header--scrolled'); // Add a class to the header
		} else {
			$('header').removeClass('header--scrolled'); // Remove it if we're back above the hero
		}
	}
});
